
export default {
  name: 'BaseAlert',
  props: {
    type: {
      type: String,
      default: 'default',
    },
  },
}
